<h1 mat-dialog-title class="title">{{"DIALOG_CONFIRM.CLOSE" | translate}}</h1>
<div mat-dialog-content>
  {{"DIALOG_CONFIRM.SURE2" | translate}}
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="dontClose()">{{("DIALOG_CONFIRM.NO" | translate).toUpperCase()}}</button>
  <button mat-button cdkFocusInitial (click)="close()">{{"DIALOG_CONFIRM.OK" | translate}}</button>
</div>
